import { render, staticRenderFns } from "./TickerSearchCard.vue?vue&type=template&id=ec6dd368"
import script from "./TickerSearchCard.vue?vue&type=script&lang=js"
export * from "./TickerSearchCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProfileImg: require('/skade-pwa/components/ui/atom/ProfileImg.vue').default,TruncateParagraph: require('/skade-pwa/components/ui/atom/TruncateParagraph.vue').default})
